import GuestActions from '../../actions/GuestActions';
import * as _ from 'lodash';
import UserStore from '../../stores/UserStore';
import GuestStore from '../../stores/GuestStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as GuestListEndPoints } from '../../constants/GuestListConstants';

import ProfileSidebar from './view/ProfileSidebar.react';
import ProfileMain from './view/ProfileMain.react';
import NotificationActions from '../../actions/NotificationActions';

class ViewProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            guest    : false,
            guest_id : this.props.guest.Guest_id,
            page     : 'personal',
            changed  : false,
        };

        this.onGuestStoreChange = this.onGuestStoreChange.bind(this);
        this.checkForChanges = this.checkForChanges.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    }

    componentWillMount() {

        GuestStore.addChangeListener(this.onGuestStoreChange);

        if (UserStore.getState().selectedLocation.UseBioTrackPOS) {

            var formData = UserStore.getApiData();
            formData.PatientScan = this.props.guest.MJStateIDNo;
            formData.ShipmentId = 0;

            AjaxPromises.POST(GuestListEndPoints.BIOTRACK_SCAN_GUEST_IN,
                formData
            ).then(res => {
                if (res.Result)
                    GuestActions.loadFullGuest(this.props.guest.Guest_id);
            });
        } else {
            GuestActions.loadFullGuest(this.props.guest.Guest_id);
        }
    }

    componentWillUnmount() {
        GuestStore.removeChangeListener(this.onGuestStoreChange);
    }

    onGuestStoreChange() {
        var self = this;
        this.setState({ guest : GuestStore.getGuestById(this.state.guest_id) }, () => {
            self.checkForChanges();
        });
    }

    checkForChanges() {
        var change   = false;
        var formData = this.refs.ProfileMain.getFormData({});
        // var formData = {};

        var guest    = this.state.guest;

        if (formData.FullName !== guest.FullName) {
            change = true;
        }

        if (formData.nickname !== guest.nickname) {
            change = true;
        }

        if (formData.gender !== guest.Gender) {
            change = true;
        }

        if (formData.dob !== moment(guest.DOB).format('YYYY-MM-DD')) {
            change = true;
        }

        if (formData.status !== guest.status) {
            change = true;
        }

        if (formData.MJStateIDNo !== guest.MJStateIDNo) {
            change = true;
        }

        var state_id_exp = '0000-00-00';
        for (var i=0; i<guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'MJStateIDNo') {
                state_id_exp = moment(guest.identifications[i].ExpirationDate).format('YYYY-MM-DD')
            }

            if (state_id_exp === 'Invalid date') {
                state_id_exp = '0000-00-00';
            }
        }

        var driver_license_id = '';
        var driver_license_id_exp = '0000-00-00';
        for (var i=0; i<guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'DriversLicenseId') {
                driver_license_id = guest.identifications[i].number;
                driver_license_id_exp = moment(guest.identifications[i].ExpirationDate).format('YYYY-MM-DD')
            }

            if (driver_license_id_exp === 'Invalid date') {
                driver_license_id_exp = '0000-00-00';
            }
        }

        if (formData.ExpirationDate !== (state_id_exp === '0000-00-00' ? '' : state_id_exp)) {
            change = true;
        }

        if (formData.DriversLicenseId !== (driver_license_id_exp === '0000-00-00' ? '' : driver_license_id_exp)) {
            change = true;
        }

        // if (formData.DLExpirationDate !== driver_license_id_exp)
        //     change = true;

        if (formData.street !== guest.address.street) {
            change = true;
        }

        if (formData.city !== guest.address.city) {
            change = true;
        }

        if (formData.state !== guest.address.state) {
            change = true;
        }

        if (formData.email !== guest.Email) {
            change = true;
        }

        if (formData.postal_code !== guest.address.postal_code) {
            change = true;
        }

        if (formData.country_code !== guest.address.Country_Code) {
            change = true;
        }

        if (formData.PhoneNo !== guest.PhoneNo) {
            change = true;
        }

        var group_1 = 0,
            group_2 = 0,
            group_3 = 0;
        for (var i=0; i<guest.discounts.length; i++) {
            if (guest.discounts[i].Group === 'Group1') {
                group_1 = guest.discounts[i].id;
            }

            if (guest.discounts[i].Group === 'Group2') {
                group_2 = guest.discounts[i].id;
            }

            if (guest.discounts[i].Group === 'Group3') {
                group_3 = guest.discounts[i].id;
            }
        }

        if (formData.Group1_Id !== group_1) {
            change = true;
        }

        if (formData.Group2_Id !== group_2) {
            change = true;
        }

        if (formData.Group3_Id !== group_3) {
            change = true;
        }

        if (formData.DoctorsName !== parseInt(guest.doctor)) {
            change = true;
        }

        if (formData.notes !== guest.notes) {
            change = true;
        }

        if (formData.CreditNote !== guest.CreditNote) {
            change = true;
        }

        if (formData.Conditions !== guest.Conditions) {
            change = true;
        }

        if (formData.CGFirstName !== guest.CGFirstName) {
            change = true;
        }

        if (formData.CGLastName !== guest.CGLastName) {
            change = true;
        }

        if (formData.CaregiverRelationship !== guest.CaregiverRelationship) {
            change = true;
        }

        if (formData.CaregiverMJStateIdNo !== guest.CaregiverMJStateIdNo) {
            change = true;
        }

        if (formData.CaregiverPhone !== guest.CaregiverPhone) {
            change = true;
        }

        if (formData.CustomIdentifier !== guest.CustomIdentifier) {
            change = true;
        }

        var CaregiverDOB = (guest.CaregiverDOB.length > 0) ? moment(guest.CaregiverDOB).format('YYYY-MM-DD') : '0000-00-00';
        if (formData.CaregiverDOB !== CaregiverDOB) {
            change = true;
        }

        var CaregiverStartDate = guest.CaregiverStartDate.length > 0 ? moment(guest.CaregiverStartDate).format('YYYY-MM-DD') : '0000-00-00';
        if (formData.CaregiverStartDate !== CaregiverStartDate) {
            change = true;
        }

        var CaregiverExpirationDate = guest.CaregiverExpirationDate.length > 0 ? moment(guest.CaregiverExpirationDate).format('YYYY-MM-DD') : '0000-00-00';
        if (formData.CaregiverExpirationDate !== CaregiverExpirationDate) {
            change = true;
        }

        if (formData.CaregiverAddress !== guest.CaregiverAddress) {
            change = true;
        }

        this.refs.ProfileSidebar.updateSaveButton(change);
    }

    saveChanges() {
        var errors = this.refs.ProfileMain.getErrors();
        if(errors) {
            NotificationActions.error(errors);
            return;
        }

        var formData        = UserStore.getApiData();

        formData.Guest_id   = this.state.guest.Guest_id;
        formData            = this.refs.ProfileMain.getFormData(formData, true);

        GuestActions.editGuestProfile(formData);
    }

    render() {
        var self    = this;

        var guest   = this.state.guest;
        var page    = this.state.page;
        var selectedLocation = UserStore.getState().selectedLocation;

        if (!guest) {
            return (
                <div
                    className='view-profile'>

                    <div className='profile__loading'>
                        LOADING PROFILE
                    </div>
                </div>
            );
        }

        return (
            <div
                className='view-profile'>

                <ProfileMain
                    guest={guest}
                    page={page}
                    selectedLocation={selectedLocation}
                    checkForChanges={() => { this.checkForChanges(); }}
                    ref='ProfileMain' />

                <ProfileSidebar
                    guest={guest}
                    page={page}
                    selectedLocation={selectedLocation}
                    goToPage={(page) => { this.setState({ page }); }}
                    saveChanges={this.saveChanges}
                    ref='ProfileSidebar' />
            </div>
        );
    }
}

export default ViewProfile;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/ViewProfile.react.jsx